import { VListItemAvatar } from "vuetify/lib";
import { getStringColor } from "kinnect-helpers";

export default {
	name: "KListTileAvatar",

	functional: true,

	props: {
		text: {
			required: true,
			type: String
		}
	},

	render( h, context ) {
		return <VListItemAvatar class="text-h5 white--text" color={getStringColor( context.props.text )}>
			{context.props.text ? context.props.text.slice( 0, 1 ).toUpperCase() : null}
		</VListItemAvatar>;
	}
};
